/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../../../common";
import type {
  ModuleProxyFactory,
  ModuleProxyFactoryInterface,
} from "../../../../../@gnosis-guild/zodiac-core/contracts/factory/ModuleProxyFactory";

const _abi = [
  {
    inputs: [],
    name: "FailedInitialization",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "address_",
        type: "address",
      },
    ],
    name: "TakenAddress",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "TargetHasNoCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "proxy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "masterCopy",
        type: "address",
      },
    ],
    name: "ModuleProxyCreation",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "masterCopy",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "initializer",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "saltNonce",
        type: "uint256",
      },
    ],
    name: "deployModule",
    outputs: [
      {
        internalType: "address",
        name: "proxy",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561000f575f80fd5b506103ba8061001d5f395ff3fe608060405234801561000f575f80fd5b5060043610610029575f3560e01c8063f1ab873c1461002d575b5f80fd5b61004061003b366004610273565b610056565b60405161004d9190610344565b60405180910390f35b5f6100998484805190602001208460405160200161007e929190918252602082015260400190565b6040516020818303038152906040528051906020012061015c565b90505f816001600160a01b0316846040516100b49190610358565b5f604051808303815f865af19150503d805f81146100ed576040519150601f19603f3d011682016040523d82523d5f602084013e6100f2565b606091505b505090508061011457604051637dabd39960e01b815260040160405180910390fd5b846001600160a01b0316826001600160a01b03167f2150ada912bf189ed721c44211199e270903fc88008c2a1e1e889ef30fe67c5f60405160405180910390a3509392505050565b5f6001600160a01b03831661018f5782604051633202e20d60e21b81526004016101869190610344565b60405180910390fd5b826001600160a01b03163b5f036101be57826040516001620dcc9f60e01b031981526004016101869190610344565b60405172602d8060093d393df3363d3d373d3d3d363d7360681b60208201526bffffffffffffffffffffffff19606085901b1660338201526e5af43d82803e903d91602b57fd5bf360881b60478201525f906056016040516020818303038152906040529050828151602083015ff591506001600160a01b038216610258578160405163371e9e8960e21b81526004016101869190610344565b5092915050565b634e487b7160e01b5f52604160045260245ffd5b5f805f60608486031215610285575f80fd5b83356001600160a01b038116811461029b575f80fd5b9250602084013567ffffffffffffffff808211156102b7575f80fd5b818601915086601f8301126102ca575f80fd5b8135818111156102dc576102dc61025f565b604051601f8201601f19908116603f011681019083821181831017156103045761030461025f565b8160405282815289602084870101111561031c575f80fd5b826020860160208301375f602084830101528096505050505050604084013590509250925092565b6001600160a01b0391909116815260200190565b5f82515f5b81811015610377576020818601810151858301520161035d565b505f92019182525091905056fea2646970667358221220c6caea73676add1e319ef187d7db5b07b0c227a63b6d174b4b6c8e636d06e10d64736f6c63430008150033";

type ModuleProxyFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ModuleProxyFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ModuleProxyFactory__factory extends ContractFactory {
  constructor(...args: ModuleProxyFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      ModuleProxyFactory & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ModuleProxyFactory__factory {
    return super.connect(runner) as ModuleProxyFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ModuleProxyFactoryInterface {
    return new Interface(_abi) as ModuleProxyFactoryInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ModuleProxyFactory {
    return new Contract(address, _abi, runner) as unknown as ModuleProxyFactory;
  }
}
